export default __webpack_public_path__ + "static/media/push35.aade29f1.gif";